import React from "react";
import { Alert, Card } from '@deere/ux.uxframe-react';

const CompanyStatus = props => {
    return (
        <div>
            {props.status === 'ASC' ?
                <div>
                    {!props.deereView ?
                        <div class="row">
                            <span class="col-sm-24">
                                <Alert>
                                    <h5 class="uxf-alert-title">Application Successfully Submitted</h5>
                                    <p class="uxf-alert-description">You will receive a confirmation email. Please follow the instructions within that email to continue your application.</p>
                                </Alert>
                            </span>
                        </div>
                        : null
                    }
                    <div class="row">
                        <span class="col-sm-24"><br />
                            <div class="stepwizard">
                                <ul class="nav nav-justified">
                                    <li class="nav-item success"><span>Application Submitted</span><small>Complete</small></li>
                                    <li class="nav-item in-process"><span>Under Review</span><small>Inprocess</small></li>
                                    <li class="nav-item"><span>Approve / Deny</span><small>Incomplete</small></li>
                                </ul>
                            </div><br />
                        </span>
                    </div>
                </div>
                : null
            }
            {props.status === 'URI' ?
                <div class="row">
                    <span class="col-sm-24"><br />
                        <div class="stepwizard">
                            <ul class="nav nav-justified">
                                <li class="nav-item success"><span>Application Submitted</span><small>Complete</small></li>
                                <li class="nav-item in-process"><span>Under Review</span><small>Inprocess</small></li>
                                <li class="nav-item "><span>Approve / Deny</span><small>Incomplete</small></li>
                            </ul>
                        </div><br />
                    </span>
                </div>
                : null
            }
            {props.status === 'A' ?
                <div>
                    <div class="row">
                        <span class="col-sm-24"><br />
                            <div class="stepwizard">
                                <ul class="nav nav-justified">
                                    <li class="nav-item success"><span>Application Submitted</span><small>Complete</small></li>
                                    <li class="nav-item success"><span>Under Review</span><small>Complete</small></li>
                                    <li class="nav-item success"><span>Approved</span><small>Complete</small></li>
                                </ul>
                            </div><br />
                        </span>
                    </div>
                    {!props.deereView ?
                        <div>
                            <div class="row">
                                <span class="col-sm-24">
                                    <h3 class="uxf-alert-title">Application Approved</h3>
                                </span>
                            </div>
                            <br />
                            <Card>
                                <div class='card-body'>
                                    <span dangerouslySetInnerHTML={{ __html: props.headerComment }} />
                                </div>
                            </Card>
                            <br />
                        </div>
                        : null
                    }
                </div>
                : null
            }
            {props.status === 'D' ?
                <div>
                    <div class="row">
                        <span class="col-sm-24"><br />
                            <div class="stepwizard">
                                <ul class="nav nav-justified">
                                    <li class="nav-item success"><span>Application Submitted</span><small>Complete</small></li>
                                    <li class="nav-item success"><span>Under Review</span><small>Complete</small></li>
                                    <li class="nav-item danger"><span>Denied</span><small>Complete</small></li>
                                </ul>
                            </div><br />
                        </span>
                    </div>
                    {!props.deereView ?
                        <div>
                            <div class="row">
                                <span class="col-sm-24">
                                    <h3 class="uxf-alert-title">Application Rejected Reason</h3>
                                </span>
                            </div>
                            <br />
                            <Card>
                                <div class='card-body'>
                                    <span dangerouslySetInnerHTML={{ __html: props.headerComment }} />
                                </div>
                            </Card>
                            <br />
                        </div>
                        : null
                    }
                </div>
                : null
            }
            {props.status === 'N' ?
                <div>
                    <div class="row">
                        <span class="col-sm-24"><br />
                            <div class="stepwizard">
                                <ul class="nav nav-justified">
                                    <li class="nav-item success"><span>Application Submitted</span><small>Complete</small></li>
                                    <li class="nav-item success"><span>Under Review</span><small>Complete</small></li>
                                    <li class="nav-item danger"><span>Not Interested</span><small>Complete</small></li>
                                </ul>
                            </div><br />
                        </span>
                    </div>
                    <div>
                        <div class="row">
                            <span class="col-sm-24">
                                <h3 class="uxf-alert-title">Application Not Interested Reason</h3>
                            </span>
                        </div>
                        <br />
                        <Card>
                            <div class='card-body'>
                                <span dangerouslySetInnerHTML={{ __html: props.headerComment }} />
                            </div>
                        </Card>
                        <br />
                    </div>
                </div>
                : null
            }
            {props.status === 'H' ?
                <div>
                    <div class="row">
                        <span class="col-sm-24"><br />
                            <div class="stepwizard">
                                <ul class="nav nav-justified">
                                    <li class="nav-item success"><span>Application Submitted</span><small>Complete</small></li>
                                    <li class="nav-item success"><span>Under Review</span><small>Complete</small></li>
                                    <li class="nav-item "><span>On Hold</span><small>Incomplete</small></li>
                                </ul>
                            </div><br />
                        </span>
                    </div>
                    <div>
                        <div class="row">
                            <span class="col-sm-24">
                                <h3 class="uxf-alert-title">Application On Hold Reason</h3>
                            </span>
                        </div>
                        <br />
                        <Card>
                            <div class='card-body'>
                                <span dangerouslySetInnerHTML={{ __html: props.headerComment }} />
                            </div>
                        </Card>
                        <br />
                    </div>
                </div>
                : null
            }
        </div>
    );
};
export default CompanyStatus;